/** Max featured products pinned to the top of a vendor storefront. */
export const MAX_FEATURED_PRODUCTS = 5;

export function normalizeFeaturedIds(raw) {
  if (!Array.isArray(raw)) return [];
  const out = [];
  for (const id of raw) {
    const s = String(id || "").trim();
    if (!s || out.includes(s)) continue;
    out.push(s);
    if (out.length >= MAX_FEATURED_PRODUCTS) break;
  }
  return out;
}

/** Pin featured IDs to the front (preserving featured order), then the rest. */
export function sortProductsWithFeatured(products, featuredProductIds) {
  const list = Array.isArray(products) ? products : [];
  const featured = normalizeFeaturedIds(featuredProductIds);
  if (!featured.length || !list.length) return list;

  const byId = new Map(list.map((p) => [String(p._id), p]));
  const ordered = [];
  const used = new Set();

  for (const id of featured) {
    const product = byId.get(id);
    if (product) {
      ordered.push(product);
      used.add(id);
    }
  }
  for (const product of list) {
    const id = String(product._id);
    if (!used.has(id)) ordered.push(product);
  }
  return ordered;
}

export function isFeaturedProduct(productId, featuredProductIds) {
  return normalizeFeaturedIds(featuredProductIds).includes(String(productId));
}
